const carouselItems = [
  {
    id: 1,
    title: '韩漫崛起：从Webtoon到全球现象',
    desc: '深度解析韩国漫画产业的崛起之路，从本土平台到全球漫迷的屏幕。',
    label: '深度专题',
    img: 'https://readdy.ai/api/search-image?query=A%20vibrant%20digital%20art%20illustration%20of%20Korean%20webtoon%20style%20characters%20in%20a%20modern%20cityscape%2C%20colorful%20dynamic%20composition%20with%20glowing%20neon%20accents%2C%20warm%20orange%20and%20pink%20tones%2C%20clean%20artistic%20background%20with%20gradients%2C%20editorial%20style%2C%20no%20text&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '2025夏季新番导览：哪些值得追？',
    desc: '新一季日漫新番全面盘点，编辑精选推荐帮你避开雷区。',
    label: '新番导览',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20summer%20themed%20anime%20style%20illustration%20with%20multiple%20characters%20under%20cherry%20blossoms%2C%20bright%20sunny%20atmosphere%20with%20warm%20golden%20light%2C%20soft%20pastel%20colors%2C%20clean%20artistic%20background%2C%20no%20text&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '武侠漫画复兴：剑与道的视觉盛宴',
    desc: '从传统武侠到玄幻修仙，漫画中的东方美学正在吸引新一代读者。',
    label: '文化观察',
    img: 'https://readdy.ai/api/search-image?query=A%20stunning%20martial%20arts%20fantasy%20illustration%20with%20flowing%20robes%20and%20ancient%20Chinese%20architecture%2C%20misty%20mountains%20background%2C%20dramatic%20ink%20wash%20painting%20style%20with%20modern%20digital%20color%20accents%2C%20warm%20earthy%20tones%2C%20no%20text&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '漫迷必看：下拉式阅读为什么更爽？',
    desc: '从交互设计角度解析垂直滚动阅读如何改变漫画消费方式。',
    label: '体验谈',
    img: 'https://readdy.ai/api/search-image?query=A%20minimalist%20modern%20illustration%20of%20a%20person%20reading%20on%20a%20mobile%20device%20with%20floating%20comic%20panels%20and%20speech%20bubbles%20around%2C%20cozy%20warm%20lighting%2C%20clean%20contemporary%20aesthetic%2C%20soft%20cream%20and%20orange%20tones%2C%20no%20text&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '从收藏夹看漫迷性格：你属于哪一类？',
    desc: '不同收藏习惯反映不同阅读性格，来测测你的追漫人格。',
    label: '趣味盘点',
    img: 'https://readdy.ai/api/search-image?query=A%20playful%20illustration%20of%20colorful%20bookshelf%20filled%20with%20manga%20volumes%20in%20various%20styles%2C%20warm%20cozy%20library%20atmosphere%2C%20organized%20chaos%20with%20character%20silhouettes%2C%20soft%20lighting%2C%20cream%20and%20warm%20brown%20tones%2C%20no%20text&width=800&height=450&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精选专题</h2>
          <p className="mt-2 text-sm text-foreground-500">深度内容与编辑推荐，发现漫画世界的更多可能</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {carouselItems.slice(0, 2).map((item) => (
            <a key={item.id} href="#cards" className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
              <div className="aspect-[16/9] overflow-hidden">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400" loading="lazy" />
              </div>
              <div className="p-4">
                <span className="inline-block px-2.5 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-2 whitespace-nowrap">{item.label}</span>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
          <a href="#cards" className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer lg:col-span-1">
            <div className="aspect-[16/9] overflow-hidden">
              <img src={carouselItems[2].img} alt={carouselItems[2].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400" loading="lazy" />
            </div>
            <div className="p-4">
              <span className="inline-block px-2.5 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-2 whitespace-nowrap">{carouselItems[2].label}</span>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">{carouselItems[2].title}</h3>
              <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">{carouselItems[2].desc}</p>
            </div>
          </a>
          <div className="sm:col-span-2 lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {carouselItems.slice(3).map((item) => (
              <a key={item.id} href="#cards" className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
                <div className="aspect-[16/9] overflow-hidden">
                  <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400" loading="lazy" />
                </div>
                <div className="p-4">
                  <span className="inline-block px-2.5 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-2 whitespace-nowrap">{item.label}</span>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">{item.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}